var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"video-preview",attrs:{"muted":"","autoplay":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }